<template>
  <SubLayout
      :pageTitle="title"
      :pageBreadcrumbs="breadcrumbs"
      :hasBack="false"
  >

    <template #layoutContent>
      <div id="chat_container">
        <ChatBox v-if="show"/>
      </div>
    </template>
  </SubLayout>

</template>

<script setup>

import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import {useRoute} from "vue-router";
import {useStore} from "vuex";
import {useHasAbility} from "@/composables/hasAbility";
import {useLocales} from "@/composables/locales";
import {onMounted, ref} from "vue";
import ChatBox from "@/Modules/Chat/components/ChatBox.vue";

const route = useRoute()
const store = useStore()
const { can } = useHasAbility()
const {locale, datatableLocaleUrl} = useLocales()

const title = ref("breadcrumbs.chat.title")
const breadcrumbs = ref([
])

const show = ref(false);


// Username: nbuteams
// Mot de passe : netbyus@2024

onMounted(() => {
  const container = document.querySelector("#kt_content2")
  const chatContainer = document.querySelector("#chat_container")

  if (container && chatContainer) {
    const height = container.getBoundingClientRect().height + 'px'

    chatContainer.style.setProperty('height', height, 'important')
    chatContainer.style.setProperty('max-height', height, 'important')

    setTimeout(() => {
      show.value = true
    }, 1000)

  } else {
    console.warn('Élément non trouvé :', { container, chatContainer })
  }
})



</script>

<style scoped>
.custom-container {

}
</style>